export default {
  en: {
    label: 'Share',
    actions: {
      facebook: 'Facebook',
      twitter: 'Twitter',
      whatsapp: 'WhatsApp',
      other_options: 'Share invitation link',
    },
  },
};
